var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-upload',{attrs:{"limit":1000,"data":_vm.dataAuth,"action":_vm.baseUrl,"show-file-list":false,"on-success":_vm.handleAvatarSuccess2,"before-upload":_vm.beforeAvatarUpload2,"file-list":_vm.fileList}},[_c('el-button',{attrs:{"size":"mini","loading":_vm.loading,"type":"primary"}},[_vm._v("上传")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }